import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`font-mono text-[11px] sm:text-xs uppercase tracking-[0.3em] text-gold ${className}`}>
    {children}
  </p>
);

export const Chip = ({ children }) => (
  <span className="inline-flex items-center rounded-full border border-slate-700/70 bg-obsidian-800/60 px-3 py-1.5 text-xs text-slate-300 transition-colors hover:border-gold/50 hover:text-gold">
    {children}
  </span>
);
